import "./nav-btn.styles.scss";
import { useContext } from "react";
import { NavContext } from "../../context/nav-context";
import { scrollToSection } from "../../utils/scroller";
import { ScrollContext } from "../../context/scroll-to";

const NavButton = () => {
    const{isClicked, setisClicked} =useContext(NavContext);
    const{navButton} = useContext(ScrollContext);
  const onClickHandler = () => {
    setisClicked(!isClicked);
    scrollToSection(navButton)
  };
  return (
    <div ref={navButton}>
      <button onClick={onClickHandler} className="btn-container">
        <div className={`${isClicked ? "changebar1 bar1": "bar1" }`}></div>
        <div className = {`${isClicked ? "changebar2 bar2": "bar2"  }`}></div>
        <div className = {`${isClicked ? "changebar3 bar3": "bar3" }`}></div>
      </button>
    </div>
  );
};

export default NavButton;
